export default __webpack_public_path__ + "static/media/big-violet-done.ed07338a.svg";